import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/authentication/auth-guard.service';
import {PAGES} from './shared/system-constants';

const routes: Routes = [
  {
    path: '',
    redirectTo: PAGES.LOG_IN,
    pathMatch: 'full'
  },
  {
    path: PAGES.LOG_IN,
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: PAGES.APP,
    loadChildren: () => import('./pages/bookings/bookings.module').then( m => m.BookingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/load/settings/settings.module').then( m => m.SettingsPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
